export default __webpack_public_path__ + "static/media/file.0578d9a0.svg";